import { QueryConfig } from "store/utils/query-config";

export const bookingDiscussionItemsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["timestamp"],
  },
};

export function bookingDiscussionItemsQueryForBooking(
  bookingId: string
): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["timestamp"] },
  };
}
